import { Routes } from '@angular/router';

import { LessonConcludeComponent } from './lesson-practice/lesson-conclude/lesson-conclude.component';
import { ProblemComponent } from './shared/problem/problem.component';
import { LessonCompletedComponent } from './lesson-practice/lesson-completed/lesson-completed.component';
import { GetStartedComponent } from './lesson-practice/get-started/get-started.component';


export const exerciseRoutes: Routes = [
  {
    path: 'exercises',
    children: [
      {
        path: ':exerciseId',
        children: [
          {
            path: 'get-started',
            component: GetStartedComponent,
            data: {
              breadcrumb: {
                currentSection: 'practice'
              }
            }
          },
          {
            path: 'persistence',
            children: [
              {
                path: '',
                component: ProblemComponent,
                data: {
                  problemCase: 'persistenceProblem',
                  breadcrumb: {
                    currentSection: 'persistence',
                  },
                  persistence: true
                }
              },
              {
                path: 'conclude',
                component: LessonConcludeComponent,
                data: {
                  breadcrumb: {
                    currentSection: 'practice'
                  },
                  persistence: true
                }
              }
            ]
          },
          {
            path: 'practice',
            component: ProblemComponent,
            data: {
              problemCase: 'practiceProblem',
              breadcrumb: {
                currentSection: 'practice'
              }
            }
          },
          {
            path: 'completed',
            component: LessonCompletedComponent,
            data: {
              breadcrumb: {
                currentSection: 'practice'
              }
            }
          },
          {
            path: 'conclude',
            component: LessonConcludeComponent,
            data: {
              breadcrumb: {
                currentSection: 'conclusion'
              }
            }
          },
        ]
      }]
  }];

